/* @flow */
import * as React from "react";
import { withColorsProvider, type ColorSet } from "./ColorsProvider";
import type { StylesObject } from "./utils/prefixStyles";
import Theme from "./Theme";

type Props = {
  description?: ?React.Node,
  icon?: ?React.Node,
  iconStyle?: ?StylesObject,
  label?: ?React.Node,
  style?: ?StylesObject,
  textWrapperStyle?: ?StylesObject,
  colors: ColorSet,
};

class RichLabel extends React.Component<Props> {
  render() {
    const {
      description,
      icon,
      iconStyle,
      label,
      style,
      textWrapperStyle,
      colors,
    } = this.props;

    const styles = {
      richLabel: {
        ...Theme.Styles.flexLayout,
        ...style,
      },
      icon: {
        marginRight: "0.25em",
        lineHeight: 0,
        fontSize: "1.5em",
        ...Theme.Styles.flexFixed,
        ...iconStyle,
      },
      label: {
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
      description: {
        color: colors.TEXT_SECONDARY,
        fontSize: "0.8em",
      },
      textWrapper: {
        lineHeight: "normal",
        minWidth: 0, // fixes a bizarre bug with text-overflow
        ...Theme.Styles.flexStretch,
        ...textWrapperStyle,
      },
    };

    return (
      <div data-component-name="RichLabel" style={styles.richLabel}>
        {icon ? (
          <div style={styles.icon} data-component-section="icon">
            {icon}
          </div>
        ) : null}
        <div style={styles.textWrapper}>
          <div style={styles.label} data-component-section="label">
            {label}
          </div>
          <div style={styles.description} data-component-section="description">
            {description}
          </div>
        </div>
      </div>
    );
  }
}

export default withColorsProvider(RichLabel);



// WEBPACK FOOTER //
// ../nx-components/src/RichLabel.jsx